import { createIcon } from '@chakra-ui/react'

export const Folder = createIcon({
  displayName: 'Folder',
  viewBox: '0 0 24 24',
  d:
    'm9.17 6 2 2H20v10H4V6h5.17ZM10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2Z',
})
